'use client';

import { LayoutContext } from '@/contexts/LayoutContext';
import { LayoutReducerActionType } from '@/types/layout';
import { extractUtmData, setUtmData } from '@lamesarv-sdk/tools';
import { useSearchParams } from 'next/navigation';
import { useContext, useEffect } from 'react';

export const HandlerUtm = () => {
  const { dispatch } = useContext(LayoutContext);

  const searchParams = useSearchParams();

  const processUtmData = () => {
    const utmData = extractUtmData({
      searchParams: searchParams,
      customUtmMap: {
        adVendor_gclAu: {
          default: '_gcl_au',
        },
      },
      overrideFromCookies: true,
    });

    if (!utmData || Object.keys(utmData).length === 0) {
      return;
    }

    dispatch({
      type: LayoutReducerActionType.updateUtmData,
      payload: utmData,
    });

    setUtmData({
      utmData,
      useSessionStorage: true,
    });
  };

  useEffect(() => {
    processUtmData();
  }, []);

  return null;
};
